import newTranslations from './et_new_translations';

export const et = {
    translations: {
        ...newTranslations,
        // Main title
        "darbuotojų_apklausa": "Mitmekesisuse ja kaasatuse hindamine",
        "Įvairovės ir įtraukties vertinimas": "Mitmekesisuse ja kaasatuse hindamine",
        "1. Socialinės distancijos vertinimas": "Sotsiaalse distantsi hindamine",
        "Socialinės distancijos vertinimas": "Sotsiaalse distantsi hindamine",
        "2. Požiūris apie įvairovę ir įtrauktį darbo vietoje": "Hinnang mitmekesisusele ja kaasatusele töökohal",
        "3. Įdarbinimo vertinimas": "Palkamise hindamine",
        "4. Įvairovės ir įtraukties vertinimas darbo vietoje": "Mitmekesisuse ja kaasatuse hindamine töökohal",
        "Įvairovės ir įtraukties vertinimas darbo vietoje": "Mitmekesisuse ja kaasatuse hindamine töökohal",
        "5. Darbuotojų gerovė": "Töötajate heaolu",
        "6. Įtraukimas į sprendimų priėmimą": "Kaasamine otsuste tegemisse",
        "7. Socialinės ir demografinės charakteristikos": "Sotsiaalsed ja demograafilised tunnused",
        "8. Kiti klausimai (neprivaloma)": "Muud küsimused (pole kohustuslik)",
        "Darbuotojų gerovė": "Töötajate heaolu",
        "Įtraukimas į sprendimų priėmimą": "Kaasamine otsuste tegemisse",
        "Socialinės ir demografinės charakteristikos": "Sotsiaalsed ja demograafilised tunnused",
        "Kiti klausimai (neprivaloma)": "Muud küsimused (pole kohustuslik)",
        "Įdarbinimo vertinimas": "Palkamise hindamine",

        "rodytiVisus": "Näita kõik",
        "pasirinkti": "Küsitluse tüüp",
        "Darbuotojų apklausa": "Töötajate küsitlus",
        "Organizacijos atstovės/-o apklausa": "Organisatsiooni esindaja küsitlus",
        "Darbuotojo forma": "Töötajate küsitlus",
        "Įmonės forma": "Organisatsiooni esindaja küsitlus",
        "filtruoti": "Filtreeri",
        "export_excel": "Laadi alla Excel",
        "export_csv": "Laadi alla CSV",
        "export_preparing": "Valmistatakse...",
        "metai": "Aasta",
        "atliko": "Läbiviija: {{kiek}}",
        "imonesLabel:":"Ettevõtte nimi",
        "1.1: Ar sutiktumėte savo kaimynystėje gyventi su žemiau išvardintais žmonėmis?": "Kas oleksite nõus oma naabruses elama järgmiste inimestega?",
        "1.2: Ar sutiktumėte dirbti toje pačioje įmonėje su žemiau išvardintais žmonėmis?": "Kas oleksite nõus töötama samas ettevõttes järgmiste inimestega?",
        "2.1: Ar, Jūsų manymu, Jūsų kolektyvas yra įvairus pagal:": "Kas teie meeskond on teie arvates mitmekesine",
        "2.1: Ar, Jūsų manymu, Jūsų kolektyvas yra įvairus": "Kas teie meeskond on teie arvates mitmekesine",
        "2.2: Ką darbovietė daro, kad užtikrintų įvairovę ir darbuotojų gerovę?": "Mida teeb töökoht mitmekesisuse ja töötajate heaolu tagamiseks?",
        "2.3: Ko norėtumėte, kad darbovietė imtųsi siekiant užtikrinti įvairovę ir darbuotojų gerovę?": "Mida sooviksite, et töökoht teeks mitmekesisuse ja töötajate heaolu tagamiseks?",
        "3.1: Klausimai darbo pokalbio metu": "Küsimused töövestluse ajal",
        "3.1: Ar darbo pokalbio metu įmonė Jūsų klausė apie:": "Küsimused töövestluse ajal",
        "3.2: Ar patyrėte diskriminaciją arba su Jumis buvo elgiamasi nesąžiningai dabartinėje darbo vietoje?": "Kas olete kogenud diskrimineerimist või ebaõiglast kohtlemist praegusel töökohal?",
        "3.2: Jeigu dabartinis darbdavys ieškotų darbuotojų ir turėtų du kandidatus su vienoda patirtimi ir kvalifikacijomis, kurie iš šių kriterijų galėtų daryti įtakos sprendimui dėl vieno arba kito kandidato pasirinkimo?": "Kas olete kogenud diskrimineerimist või ebaõiglast kohtlemist praegusel töökohal?",
        "4.1: Ar darbovietėje girdėjote nemalonių komentarų ar juokelių apie save arba kitus asmenis?": "Kas olete kuulnud ebameeldivaid kommentaare või nalja enda või teiste inimeste kohta töökohal?",
        "4.2: Hipotetinių situacijų vertinimas": "Hüpoteetiliste olukordade hindamine",
        "4.2: Kaip Jūs vertinate šias hipotetines situacijas:": "Hüpoteetiliste olukordade hindamine",
        "4.5: Jei Jūs ar Jūsų kolega patirtų diskriminacijos darbo vietoje, ar jaustumėtės saugus  apie tai papasakoti kolegoms?": "Kui teie või teie kolleeg kogeks diskrimineerimist töökohal, kas tunneksite end turvaliselt rääkides sellest kolleegidele?",
        "4.6: Ar Jūsų darbo vietoje yra saugus pranešimo kanalas?": "Kas teie töökohal on turvaline teatamiskanal?",
        "4.7:  Jei Jūs ar Jūsų kolega patirtų diskriminaciją darbo vietoje, ar norėtumėte apie tai pranešti?": "Kui teie või teie kolleeg kogeks diskrimineerimist töökohal, kas sooviksite sellest teatada?",
        "4.3: Ar darbuotojai patyrė diskriminacijos arba ar su Jais buvo elgiamasi nesąžiningai dabartinėje darbo vietoje": "Kas töötajad on kogenud diskrimineerimist või ebaõiglast kohtlemist praegusel töökohal",
        "4.4: Ar žinote kolegą (-ę), kurie darbovietėje buvo diskriminuojami?": "Kas teate kolleegi, keda on töökohal diskrimineeritud?",
        "5.1: Kiek žinote apie iššūkius, su kuriais susiduria skirtingi gyventojai?": "Kui palju teate erinevatele elanikele esitatavatest väljakutsetest?",
        "5.1: Kiek žinote apie iššūkius, su kuriais susiduria gyventojai, kurie yra:": "Kui palju teate erinevatele elanikele esitatavatest väljakutsetest?",
        "5.2: Darbuotojų savijauta darbe": "Töötajate enesetunne tööl",
        "5.2: Prašome įvertinti kiekvieną klausimą apie Jūsų įmonę naudodami skalę.": "Töötajate enesetunne tööl",
        "5.3: Darbovietės vertinimas": "Töökoha hindamine",
        "5.3: Prašome įvertinti kiekvieną klausimą apie Jūsų įmonę naudodami skalę.": "Töökoha hindamine",
        "5.4:  Ar dabartinėje darbo vietoje teko patirti patyčių ar priekabiavimo?": "Kas olete kogenud kiusamist või ahistamist oma praegusel töökohal?",
        "6.1: Darbuotojų įtraukimas į sprendimų priėmimą": "Töötajate kaasamine otsuste tegemisse",
        "6.1: Prašome įvertinti kiekvieną klausimą apie Jūsų įmonę naudodami skalę.": "Töötajate kaasamine otsuste tegemisse",

        "deaktyvuoti": "Deaktiveerida",
        "Nera_ats": "Vastuseid pole",
        "Nera_atsakymu": "Vastuseid pole",
        "Prašome atsakyti į klausimą": "Palun vastake küsimusele",
        "prisijungti": "Logi sisse",
        "registruotis": "Registreeru",
        "login_email": "E-post",
        "vardas_pavarde": "Ees- ja perekonnanimi",
        "imones_pav": "Ettevõtte nimi",
        "telNr": "Telefon",
        "login_pass": "Parool",
        "esu_organizacijos_atstovas": "Olen volitatud organisatsiooni esindaja ja võin luua konto organisatsiooni nimel",
        "susipazinau_su_taisyklem": "Olen tutvunud privaatsuspoliitika ja tingimustega",
        "pamirsai_pass": "Unustasid parooli?",
        "slaptazodzio_priminimas": "Parooli meeldetuletus",
        "slaptazodzio_priminimas_txt": "Parooli meelde tuletamiseks sisestage sisselogimiseks kasutatav e-posti aadress",
        "kopijuoti": "Kopeeri",
        "kopijuoti_nuoroda": "Kopeeri link",
        "grizti_i_prisijungima": "Tagasi sisselogimise lehele",
        "prisiminti": "Saada kood",
        "refresh": "Värskenda",
        "loading": "Laadimine...",
        "atlikti_apklausa": "Hinda",
        "statusas": "Olek",
        "statusas_label": "Olek",
        "Sustabdyta": "Peatatud",
        "Nepaviešinta": "Avaldamata",
        "paviesinta": "Avaldatud",
        "Paviešinta": "Avaldatud",

        kalba_text: ['LT', 'EN', 'RU', 'ET', 'LV'],
        kalba: ['lt', 'en', 'ru', 'et', 'lv'],
        linkaiAdminText: ['Ettevõtted', 'Tulemused', 'Punktid', 'Küsitlused'],
        linkaiNeAdminText: ['Teha hindamine', 'Tulemused', 'Punktid'],
        
        "prenumeratos_valdymas": "Tellimuse haldamine",
        
        'galioja_iki': 'Kehtib kuni',
        'neribotai': 'Piiramatu',
        'pasirinkti_data': 'Vali kuupäev',
        'vieneri_metai': 'Üks aasta',

        // Add other translations similarly
        'atlikti_vertinima_label': 'Teha hindamine',
        statusas_text: ['Peatatud', 'Avaldamata', 'Avaldatud'],

        // Chart controls
        "sort_by": "Sorteeri",
        "sort_order": "Sorteerimise järjekord",
        "sort_ascending": "Kasvav järjekord",
        "sort_descending": "Kahanev järjekord",
        "chart_type": "Graafiku tüüp",
        "bar_chart": "Tulpdiagramm",
        "pie_chart": "Sektordiagramm",
        "radar_chart": "Radardiagramm",
        "radial_chart": "Radiaalne diagramm",
        "table_view": "Tabel",

        // Registration success messages
        "sekminga_reg": "Registreerimine õnnestus!",
        "sekminga_reg_txt1": "Me aktiveerime teie profiili või võtame teiega ühendust 3 tööpäeva jooksul. Kui teil on küsimusi, palun kirjutage meile e-posti aadressil diversity@diversity.lt",

        // Create survey button
        "sukurti_apklausa": "Loo küsitlus",
        "Create": "Loo küsitlus",

        // Score translations
        "balas": "Punktid",
        "is_10_galimu": "Maksimaalselt 10",
        "rezultataiTendencijos": "Punktid",
        "rodoma": "Näidatakse:",

        // Survey type options
        "Darbuotojų apklausa": "Töötajate küsitlus",
        "Įmonės forma": "Organisatsiooni esindaja küsitlus",
        "Darbuotojo forma": "Töötajate küsitlus",
        pildytojuTipaiText: ['Töötajate küsitlus', 'Organisatsiooni esindaja küsitlus', 'Üldine tulemus'],
        pildytojuTipaiText2: ['Töötajate küsitlus', 'Organisatsiooni esindaja küsitlus'],
        tipas_text: ['Töötajate küsitlus', 'Organisatsiooni esindaja küsitlus'],

        // Filter labels
        "lytysLabel": "Sugu",
        "laikaiLabel": "Kui kaua on töötanud",
        "padetysLabel": "Perekonnaseis",
        "pareigomsLabel": "Ametikoht organisatsioonis",
        "religijosLabel": "Kas olete usklik?",
        "LGBTLabel": "Kas olete lesbi, gei, biseksuaal või muu mitteheteroseksuaalse seksuaalse orientatsiooniga?",
        "negaliosLabel": "Kas teil on puue?",
        "neuroskirtingiLabel": "Kas olete neuroerinev?",
        "pilietybesLabel": "Mis on teie kodakondsus?",
        "orientacijosLabel": "Seksuaalne orientatsioon",

        // Filter arrays
        lytysText: ['Mees', 'Naine', 'Muu', 'Ei ütle'],
        amziaiText: ['18-34 aastat', '35-54 aastat', '55-74 aastat', '75 aastat või vanem', 'Ei ütle'],
        padetysText: ['Abielus', 'Kooselus', 'Vallaline', 'Lahutatud', 'Ei ütle', 'Muu'],
        laikaiText: ['Kuni 1 aasta', '1-5 aastat', '5-10 aastat', 'Üle 10 aasta'],
        pareigomsText: ['Tippjuht', 'Keskastme juht', 'Esimese taseme juht', 'Töötaja/spetsialist', 'Muu'],
        kompiuteriaiText: ['Mul on tööks isiklik arvuti', 'Töötan ühistel arvutitel', 'Ei tööta arvutiga'],
        issilavinimaiText: ['Algharidus', 'Keskharidus', 'Kõrgharidus', 'Muu'],
        religijosText: ['Jah', 'Ei', 'Ei tea', 'Ei ütle'],
        LGBTText: ['Jah', 'Ei', 'Ei ütle'],
        negaliosText: ['Jah', 'Ei', 'Ei ütle'],
        neuroskirtingiText: ['Jah', 'Ei', 'Ei ütle'],
        pilietybesText: [
            'Leedu kodanik',
            'Läti kodanik',
            'Eesti kodanik',
            'EL liikmesriigi kodanik',
            'Mitte-EL kodanik',
            'Mul ei ole kodakondsust.'
        ],
        orientacijosText: ['Aseksuaalne', 'Biseksuaalne', 'Homoseksuaalne', 'Heteroseksuaalne', 'Muu', 'Ei ütle'],
        pilietybes: [
            'Lietuvos pilietė/-is',
            'Latvijos pilietė/-is',
            'Estijos pilietė/-is',
            'ES valstybės pilietė/-is',
            'Ne ES valstybės pilietė/-is',
            'Neturiu pilietybės'
        ],
        neuroskirtingi: ['Taip', 'Ne', 'Nesakysiu'],

        // Individual translations for filter items
        'Vyras': 'Mees',
        'Moteris': 'Naine',
        'Kita': 'Muu',
        'Nesakysiu': 'Ei ütle',
        "Lytis": "Sugu",
        "Amzius": "Vanus",
        "Neuroskirtingas": "Neuroerinev",
        "Pilietis": "Kodakondsus"
    }
}
